import { STARK_KEY_SIGNATURE_VERSION } from '#/features/wallet/chain';

const KEY_PREFIX = 'paradex';

export function getPreferredLanguageStorageKey() {
  return getStorageKey(`preferred-language`);
}

export function getStarknetWalletSeedStorageKey(chainId: number) {
  return getStorageKey(
    `starknet-wallet-seed-${STARK_KEY_SIGNATURE_VERSION}-${chainId}`,
  );
}

export const STORAGE_KEY_ETHEREUM_WALLET_ADDRESS = getStorageKey(
  `ethereum-wallet-address`,
);

export const getUserPreferencesStorageKey = (userId: string | null) => {
  return getUserStorageKey('user-preferences', userId);
};

export const getIsEthereumWalletCompliantStorageKey = (
  ethereumAddress: string,
) => {
  return getStorageKey(`is-ethereum-wallet-compliant-${ethereumAddress}`);
};

export function getUserStorageKey(keyId: string, userId: string | null) {
  const keySuffix = userId ?? 'unauthenticated';
  const fullKey = getStorageKey(`${keyId}-${keySuffix}`);
  return fullKey;
}

function getStorageKey(keyId: string) {
  return `${KEY_PREFIX}-${keyId}`;
}
